import {
  Button,
  Flex,
  Icon,
  InputItem,
  List,
  NavBar,
  Picker,
} from "antd-mobile";
import { useEffect, useState } from "react";
import { bottomBtnStyle } from "..";
import instance from "../../../../util/axios";
import { DictionaryOption } from "../schema";
import { formatNumber } from "../util";

export interface TrainingProduct {
  product?: string[];
  productName?: string;
  amount?: string;
  agency?: string;
}

interface TrainingStepTwoProps {
  onCancel?: () => void;
  onOk?: (data: TrainingProduct) => void;
  defaultValues?: TrainingProduct;
}
const isIPhone = new RegExp("\\biPhone\\b|\\biPod\\b", "i").test(
  window.navigator.userAgent
);
let moneyKeyboardWrapProps: object | undefined;
if (isIPhone) {
  moneyKeyboardWrapProps = {
    onTouchStart: (e: { preventDefault: () => any }) => e.preventDefault(),
  };
}

const TrainingStepTwo = ({
  onCancel,
  onOk,
  defaultValues,
}: TrainingStepTwoProps) => {
  const [data, setData] = useState<TrainingProduct>({});
  const [productDictionary, setProductDictionary] = useState<
    DictionaryOption[]
  >([]);

  useEffect(() => {
    if (defaultValues && JSON.stringify(defaultValues) !== "{}") {
      setData(defaultValues);
    }
  }, [defaultValues]);

  useEffect(() => {
    instance
      .get(
        `/crm/common/CommonApi/GetZLSelectDict?pageIndex=&pageSize=&dictionaryName=v_psi_sku_inner_training
&key=&selectId=&filter=&colName=&isFull=true`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setProductDictionary(
            resp.data.Data.map((item: { uuid: any; name: any }) => ({
              value: item.uuid,
              label: item.name,
            }))
          );
        }
      });
  }, []);
  return (
    <>
      <NavBar icon={<Icon type="left" onClick={onCancel} />}>
        销售及内训订单
      </NavBar>
      <List>
        <div className="titleDiv">产品1</div>
        <Picker
          data={productDictionary}
          cols={1}
          value={data?.product}
          onChange={async (value: any) => {
            const resp = await instance.post(`/wf/form/vsheet/loadRelated`, {
              request: JSON.stringify({
                dataSourceTableName: "psi_sku",
                requestFieldMaps: [
                  {
                    vSheetFieldName: "内训_产品名称",
                    dataSourceFieldName: "uuid",
                    value: value[0],
                  },
                ],
                resultFieldMaps: [
                  {
                    vSheetFieldName: "内训_单价",
                    dataSourceFieldName: "price",
                  },
                ],
              }),
            });
            if (
              resp.data.Status === "1" &&
              resp.data.Data &&
              resp.data.Data.resultFieldMaps &&
              resp.data.Data.resultFieldMaps.length > 0
            ) {
              setData({
                ...data,
                product: value,
                amount: resp.data.Data.resultFieldMaps[0].value,
                productName: productDictionary.find(
                  (item) => item.value === value[0]
                )!?.label,
              });
            }
          }}>
          <List.Item arrow="horizontal">请选择产品</List.Item>
        </Picker>
        <InputItem
          placeholder="请输入"
          extra="元"
          value={data?.amount}
          type="money"
          moneyKeyboardWrapProps={moneyKeyboardWrapProps}
          onChange={(value) =>
            setData({
              ...data,
              amount: formatNumber(value),
            })
          }>
          合同金额
        </InputItem>
        <InputItem
          placeholder="请输入"
          value={data?.agency}
          onChange={(value) =>
            setData({
              ...data,
              agency: value,
            })
          }>
          签约单位
        </InputItem>
      </List>
      <Flex style={bottomBtnStyle}>
        <Flex.Item>
          <Button type="primary" onClick={onCancel}>
            上一步
          </Button>
        </Flex.Item>
        <Flex.Item>
          <Button type="primary" onClick={() => onOk?.(data)}>
            下一步
          </Button>
        </Flex.Item>
      </Flex>
    </>
  );
};

export default TrainingStepTwo;
